import React from 'react';
import { useTranslation, Trans } from "react-i18next";

import { useState } from 'react';

import '../../resources/styles/secondary-lp.scss';
import './Contact.scss';

import icon_mail from './img/icon_mail.png';

import { AppModelService } from '../../AppModel';

const ContactComponent = (props) => {

    const { t } = useTranslation();

    //const { register, handleSubmit, reset } = useForm();

    

    //const { register, handleSubmit } = useForm();
    let [result, setResult] = useState({ done: false, success: false, text: 'xx' });
    let [data, setData] = useState({})

    const getTextResult = () => {
        return result ? result.text : 'no result';
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
       
        data[name] = value;
       
        setData(data);

        //console.log(data);
        if (result.done && !result.saving) {
             setResult({ done: false, success: false, text: '' });
        }
    }
    const reset = () => {
        try {
            document.getElementById("contact-milluu-form")["name"].value = '';
            document.getElementById("contact-milluu-form")["email"].value = '';
            document.getElementById("contact-milluu-form")["message"].value = '';
        }
        catch (error) {
            console.error(error);
        }
    }

    const onSubmit = (d) => {
        d.preventDefault();
        //console.log(data);

        if (result.saving) {
            console.log('skip');
            return;
        }

        setResult({ done: false, saving: true });

        let formData = new FormData();
        formData.append('nume', data.name);
        formData.append('email', data.email);
        formData.append('mesaj', data.message);

        setResult({ done: false, success: false, text: '' });

        //fetch('w/emailsend-milluu.php', {
        fetch( AppModelService.getCountry() == 'pl' ?  '/w/emailsend-milluu.php' : '/emailsend-milluu.php', {
            method: 'POST',
            headers: {
                //'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        })
            .then((response) => {

                response.json()
                    .then((responseData) => {

                        let success = (responseData && (responseData.type == 'success' || responseData.type == 'succes') ) ? true : false;
                        let text = '';
                        
                        if (responseData.error_code) {
                            text = t('contact.error_' + responseData.error_code) || text;
                        }
                        else {
                            if (!success) {
                                text = t('contact.message_not_sent');
                            }
                            else {
                                text = t('contact.message_sent');
                            }
                        }

                        setResult({ done: true, success: success, text: text });
                        if (success) {
                            reset();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        setResult({ done: true, success: false, text: t('contact.message_not_sent') });
                    })
                    .finally(() => {
                        
                    })

            })
            .catch((error) => {
                console.error(error);
                setResult({ done: true, success: false, text: t('contact.message_not_sent') });
            });
    }


    return (
        <div className='contact-component secondary-lp' >
            <div className="container contact-container">
                <div className='row'>
                    <div className="col-md-6">
                        <div className='c-formular'>
                            <h1>{t('contact.title')}</h1>
                            <form onSubmit={onSubmit} id='contact-milluu-form' autoComplete="off">
                                <input type="text" name="name" id="fname" 
                                    placeholder={t('contact.name')} required onChange={handleInputChange} />
                                
                                <input type="email" name="email" id="email_address" 
                                    placeholder={t('contact.email')} required onChange={handleInputChange} />
                                
                                <textarea name="message" id="message" 
                                    placeholder={t('contact.message')} required onChange={handleInputChange}></textarea>
                                
                                <div className='w-100 d-flex justify-content-end mt-3'>
                                    <button type='submit' className='ml-auto btn btn-secondary'>{t('contact.send')}</button>
                                </div>

                            </form>
                        </div>
                    </div>
                    <div className="col-md-6 c-info order-first order-md-2">
                        <h4>{t('contact.subtitle')}</h4>
                        <ul className="info-list p-1">
                            <li>
                                <a href={'mailto:'+t('contact.milluu_email')}>
                                    <div className='d-flex align-items-center'>
                                        <div className='contact-icon'>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="16"  width="16" fill='currentColor' viewBox="0 96 960 960"><path d="M180.309 843.999q-26.308 0-45.308-19t-19-45.308V372.309q0-26.308 19-45.308t45.308-19h599.382q27.308 0 45.808 19t18.5 45.308v407.382q0 26.308-18.5 45.308t-45.808 19H180.309ZM480 606.306l312-183.615L785.846 360 480 539 174.154 360 168 422.691l312 183.615Z"/></svg>
                                        </div>                                
                                        <span>
                                            {t('contact.milluu_email')} 
                                        </span>
                                    </div>
                                </a>
                            </li>

                            <li>
                                <a href={'tel:'+t('callToActionCall.phone')}>
                                    <div className='d-flex align-items-center'>
                                            <div className='contact-icon'>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 96 960 960" width="16" fill='currentColor'>
                                                    <path d="M742.229 888.691q-110.691-10-211.614-59.385-100.922-49.384-178.806-127.769-77.885-78.384-127.961-179.114-50.077-100.73-59.077-211.422-2-21 12.5-36.5t35.5-15.5H317.23q18.539 0 31.616 10.577 13.076 10.577 17.846 28.731L387.615 383q2.384 12.769-1 25.346-3.385 12.577-13.154 21.577l-92.385 89.923q47.385 84.462 110.693 147.385 63.308 62.923 146.232 107.231l94.384-92.923Q643.154 670.77 654 668.655q10.846-2.116 21.846.269l80.075 17.615q18.154 4.385 28.731 18.154 10.577 13.769 10.577 32.308v103.69q0 27-19 38t-34 10Z"/>
                                                </svg>
                                            </div>                                
                                            <span>
                                                {t('callToActionCall.phone')} 
                                            </span>
                                        </div>
                                </a>
                            </li>

                            <div>
                                {
                                    result && result.done && !result.success &&
                                    <div className="text-danger">{getTextResult()}</div>
                                }
                                {
                                    result && result.done && result.success &&
                                    <div className="text-success">{t(getTextResult())}</div>
                                }
                            </div>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactComponent;